import { render, staticRenderFns } from "./SkillExercise.vue?vue&type=template&id=1a3cc9c6&scoped=true"
import script from "./index.js?vue&type=script&lang=js&external"
export * from "./index.js?vue&type=script&lang=js&external"
import style0 from "./SkillExercise.vue?vue&type=style&index=0&id=1a3cc9c6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a3cc9c6",
  null
  
)

export default component.exports